<template>
  <v-card flat>
    <v-card-text class="py-0" v-if="infoWindowItem">
      <div v-if="options.type == 'marker'">
        {{ infoWindowItem[options.infoText] }}
      </div>
      <div v-else>
        <div class="caption" v-if="!infoWindowItem.FullName">
          <div v-if="options.message" class="primaryDark--text">{{ options.message }}</div>
          <div v-if="typeof infoWindowItem[options.infoText] == 'string'">
            <router-link
              target="_blank"
              :to="`/${infoWindowItem[options.type] == 'outside' ? 'device' : options.url}/${
                infoWindowItem[options.id]
              }`"
              ><b>{{ infoWindowItem[options.infoText] }}</b></router-link
            >
          </div>
          <div v-else>
            <span class="pr-2" v-for="(item, idx) in infoWindowItem[options.infoText]" :key="idx"
              ><router-link target="_blank" :to="`/device/${item}`"
                ><b>{{ item }}</b></router-link
              ></span
            >
          </div>
        </div>
        <div class="caption mb-2" v-if="infoWindowItem.FullName">
          <div>
            <b>{{ infoWindowItem.FullName }}</b> -
            {{ infoWindowItem.LocationCategory }}
          </div>

          <div class="mt-2 d-flex">
            <div>
              Rate of Flow -
              {{ $percentage(infoWindowItem.FlowRate) }}
            </div>
          </div>
        </div>
        <div class="caption text-no-wrap d-flex" v-if="infoWindowItem.FullName">
          <div class="mr-2">
            Avg. Stay Duration
            <div>{{ infoWindowItem.Utilisation | timeSince }}</div>
          </div>
          <div class="mr-2">
            Total Assets
            <br />
            <span>
              <b>{{ $emptyCheck(infoWindowItem.TotalAssets) }}</b>
            </span>
          </div>
          <div>
            Assets Allocation
            <div class="mt-1">
              <DistributionBarVT
                :values="page_config.AssetAllocation.values"
                :item="infoWindowItem"
                :colors="page_config.AssetAllocation.colors"
                :labels="page_config.AssetAllocation.labels"
              />
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DistributionBarVT from "./DistributionBarVT";
import { content } from "./../../config/locations.js";

export default {
  name: "MapInfoWindowTemplate",
  components: { DistributionBarVT },
  props: { infoWindowItem: Object, options: Object },
  data: function () {
    return {
      page_config: {},
    };
  },
  created() {
    this.page_config = content;
  },
};
</script>
